import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Camera, KeyRound, GraduationCap } from "lucide-react";

const CONFIG = {
  "/real-estate": { label: "Work With Bahare", icon: KeyRound, target: "#re-inquiry" },
  "/learn": { label: "Request a Class", icon: GraduationCap, target: "#class-inquiry" },
};

export default function MobileBookBar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (pathname === "/book" || pathname.startsWith("/admin") || pathname.startsWith("/portal")) return null;

  const cfg = CONFIG[pathname];
  const label = cfg?.label || "Book a Session";
  const Icon = cfg?.icon || Camera;

  const go = () => {
    if (cfg) {
      document.querySelector(cfg.target)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/book");
    }
  };

  return (
    <motion.div initial={{ y: 80 }} animate={{ y: 0 }} transition={{ delay: 1.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="mobile-book-bar" className="lg:hidden fixed bottom-0 left-0 right-0 z-50 p-4 pb-5 bg-gradient-to-t from-[#F9F9F8] via-[#F9F9F8]/95 to-transparent">
      <button onClick={go} data-testid="mobile-book-bar-btn"
        className="w-full bg-[#1A1A1A] text-[#F9F9F8] text-[12px] uppercase tracking-[0.22em] py-4 rounded-full flex items-center justify-center gap-2 active:bg-[#4A4A4A] transition-colors">
        <Icon size={15} strokeWidth={1.5} /> {label}
      </button>
    </motion.div>
  );
}
